export default "__VITE_ASSET__Ocuf_0CL__"